import {Component, OnInit} from '@angular/core';
import {Testbed} from "../../../model/testbed";
import {Box} from "../../../model/box";
import {SnackService} from "../../../services/snack.service";
import {AuthService} from "../../../services/auth.service";
import {BoxesService} from "../../../services/boxes-service";
import {UsersService} from "../../../services/users.service";
import {MatDialog} from "@angular/material/dialog";
import {DialogsService} from "../../../services/dialogs.service";
import {TestbedsService} from "../../../services/testbeds.service";
import {hasPermission, User} from "../../../model/user";
import {OnSutBoxInterface, SutBoxInterface} from "../../../model/box-interface";
import {BoxInterfacesService} from "../../../services/box-interfaces.service";

type SutBox = Box & { sutInterfaces?: OnSutBoxInterface[] };

@Component({
  selector: 'aw-box-configuration-page',
  templateUrl: './box-configuration-page.component.html',
  styleUrls: ['./box-configuration-page.component.scss']
})
export class BoxConfigurationPageComponent implements OnInit {

  loading = false;
  saving = false;
  amIAdmin: boolean;
  amICustomer: boolean;
  sutBoxInterfacesTypes?: SutBoxInterface[];

  testbeds: Testbed[] = [];
  selectedTestbed?: Testbed;

  boxes: SutBox[] = [];
  private loggedUser: User;

  constructor(
    private boxesService: BoxesService,
    private boxesInterfacesService: BoxInterfacesService,
    private testbedsService: TestbedsService,
    private snack: SnackService,
    private auth: AuthService,
  ) {
  }

  ngOnInit(): void {
    this.loggedUser = this.auth.loggedUser()!;
    this.amIAdmin = hasPermission(this.loggedUser, 'admin');
    this.amICustomer = hasPermission(this.loggedUser, "customer");

    this.boxesInterfacesService.getAllSutBoxInterfaces().subscribe(value => this.sutBoxInterfacesTypes = value);
    this.loadTestbeds();

  }

  loadTestbeds(): void {
    this.loading = true;

    (this.amIAdmin ? // if not admin, is it surely customer
      this.testbedsService.getAllTestbeds() :
      this.testbedsService.getAllTestbedsByCompany(this.loggedUser.company.id))
      .subscribe({
        next: (res) => {
          this.testbeds = res;
          this.loading = false;
        },
        error: () => {
          this.snack.error("Error loading testbeds");
          this.loading = false;
        }
      });
  }

  onSelectTestbed(testbed: Testbed): void {
    this.selectedTestbed = testbed;
    this.loadBoxes();
  }

  loadBoxes(): void {

    this.boxes = [];

    if (this.selectedTestbed.contracts.length == 0) {
      return;
    }

    this.loading = true;

    this.boxesService
      .getAllBoxesByContract(this.selectedTestbed.contracts[0])
      .subscribe({
        next: (res) => {
          this.boxes = res;
          this.loading = false;
        },
        error: () => {
          this.snack.error("Error loading boxes");
          this.loading = false;
        }
      });
  }


  addInterface(box: SutBox): void {

    const hasEmpty = box.sutInterfaces.some(i => !i.ifName?.trim() || !i.qualifiedName);

    if (hasEmpty) {
      this.snack.error('Please fill the existing empty interface before adding a new one.');
      return;
    }

    box.sutInterfaces.push({qualifiedName: undefined, ifName: undefined});

  }

  removeInterface(box: SutBox, index: number): void {
    box.sutInterfaces?.splice(index, 1);
  }

  hasEmptyInterface(box: SutBox): boolean {
    return box.sutInterfaces?.some(i => !i.ifName?.trim()) ?? false;
  }

  saveBox(box: SutBox): void {

    if (box.sutInterfaces?.some(i => !i.ifName?.trim() || !i.qualifiedName)) {
      this.snack.error("All interfaces must have a name and a type");
      return;
    }

    this.saving = true;

    // update
    this.boxesInterfacesService
      .saveSutBoxInterfaces(this.selectedTestbed.id, box.id, box.sutInterfaces)
      .subscribe({
        next: () => {
          this.snack.success("Box updated");
          this.saving = false;
        },
        error: () => {
          this.snack.error("Error saving box");
          this.saving = false;
        }
      });
  }

  isBoxValid(box: SutBox): boolean {
    if (!box.identifier?.trim()) return false;

    return !box.sutInterfaces?.some(i => !i.ifName?.trim() || !i.qualifiedName);

  }


  protected loadSutBoxInterfaces(box: SutBox): void {

    if (box.sutInterfaces == undefined) {
      this.boxesInterfacesService
        .getSutBoxInterfaces(this.selectedTestbed.id, box.id)
        .subscribe(value => box.sutInterfaces = value);
    }

  }
}
